<script setup lang="ts">
const { data } = await useApi('/training/get-available-games', { key: 'training-get-available-games' })

const localePath = useLocalePath()

definePageMeta({
  middleware: ['auth'],
})
</script>

<template>
  <UiPage
    padding
    :title="$t('Training games')"
    :description="$t('Play training games and gain experience!')"
  >
    <template #top-below>
      <training-toolbar />
    </template>

    <UiAlert
      variant="info"
      :title="$t('More games coming soon!')"
      :description="$t('We are working on adding more games to the platform')"
    />

    <UiCard :title="$t('Available games')">
      <template #content>
        <UiList v-if="data">
          <TrainingGameQItem
            v-for="game in data"
            :key="game.slug"
            :game="game"
            :to="localePath('/play/training/games/' + game.slug)"
          />
        </UiList>
      </template>
    </UiCard>
  </UiPage>
</template>
